import { render, staticRenderFns } from "./workspace-setting.vue?vue&type=template&id=35f067e4&scoped=true&"
import script from "./workspace-setting.vue?vue&type=script&lang=ts&"
export * from "./workspace-setting.vue?vue&type=script&lang=ts&"
import style0 from "./workspace-setting.vue?vue&type=style&index=0&id=35f067e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f067e4",
  null
  
)

/* custom blocks */
import block0 from "./workspace-setting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports